import { create } from 'zustand';

/**
 * In-memory banner state. The persisted decision lives in localStorage (see
 * analytics/consent.ts); this store only tracks the two things React needs to
 * react to at runtime: whether the visitor has now decided this page load, and
 * whether they explicitly reopened the banner via "Your Privacy Choices".
 */
interface ConsentUiState {
  /** Set once the visitor makes a choice this page load, so the banner hides
   *  without waiting for a storage round trip. */
  decidedThisSession: boolean;
  /** True when reopened from the footer even though a decision already exists. */
  reopenRequested: boolean;
  markDecided: () => void;
  requestReopen: () => void;
  clearReopen: () => void;
}

export const useConsentStore = create<ConsentUiState>((set) => ({
  decidedThisSession: false,
  reopenRequested: false,
  markDecided: () => set({ decidedThisSession: true, reopenRequested: false }),
  requestReopen: () =>
    set({ reopenRequested: true, decidedThisSession: false }),
  clearReopen: () => set({ reopenRequested: false })
}));
